<app-dialog
  id="assign-salesperson"
  [title]="'dealEditor.dialog.assignSalesperson.header' | translate"
  [confirmation]="'button.yes' | translate"
  (save)="onSave()">
  <p class="pb-2" [innerHTML]="'dealEditor.dialog.assignSalesperson.body' | translate: { salesperson: salespersonEmail }"></p>
</app-dialog>